import { render, staticRenderFns } from "./fiche_info_matieres.vue?vue&type=template&id=be51b116"
import script from "./fiche_info_matieres.js?vue&type=script&lang=js&external"
export * from "./fiche_info_matieres.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports